import { render } from "./XModal.vue?vue&type=template&id=d7a0fc00&scoped=true"
import script from "./XModal.vue?vue&type=script&lang=js"
export * from "./XModal.vue?vue&type=script&lang=js"

import "./XModal.vue?vue&type=style&index=0&id=d7a0fc00&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7a0fc00"]])

export default __exports__